const rotas = [
    {
        path: '/dashboard-posvendas',
        name: 'Dashboard Pós-vendas',
        component: () => import("@/views/PosVendas/Dashboard.vue"),
        meta: {
            obraObrigatoria: false,
            title: "Dashboard",
            icon: 'mdi-view-dashboard-outline',
            subject: ['POSVENDAS'],
            action: ['read'],
            showMenu: true,
            grupo: "POSVENDAS",
            grupoTitle: "Pós-vendas"
        },
    },
    {
        path: '/posvendas-satisfacao',
        name: 'Dashboard Satisfação de Pós-vendas',
        component: () => import("@/views/PosVendas/DashboardSatisfacao.vue"),
        meta: {
            obraObrigatoria: false,
            title: "Dashboard Satisfação",
            icon: 'mdi-monitor-star',
            subject: ['POSVENDAS'],
            action: ['read'],
            showMenu: true,
            grupo: "POSVENDAS",
            grupoTitle: "Pós-vendas"
        },
    },
    {
        path: '/posvendas',
        name: 'Tickets Pós-vendas',
        component: () => import("@/views/PosVendas/TodosTickets.vue"),
        meta: {
            title: "Todos Tickets",
            icon: 'mdi-account-switch-outline',
            subject: ['POSVENDAS'],
            showMenu: true,
            grupo: "POSVENDAS",
            grupoTitle: "Pós-vendas"
        },
    },
    {
        path: '/posvendas/:ticket',
        name: 'Ticket',
        component: () => import("@/views/PosVendas/Ticket.vue"),
        meta: {
            breadcrumb: 'Tickets Pós-vendas',
            title: "Ticket",
            icon: 'mdi-account-switch-outline',
            subject: ['POSVENDAS'],
            showMenu: false,
            grupo: "POSVENDAS",
            grupoTitle: "Pós-vendas"
        },
    },
]

export default rotas;